import React from 'react';
import cn from "../../lib/bem";

import './cardSeguro_component.scss';

const CardSeguroComponent = (props) => {
    
    const classes = cn("cardSeguroComponent");

    return (
        <div className={classes()}>
            <div>
                <img src={props.ico} alt={props.ico} />
            </div>
            <div>
                <p className={classes('cardSeguroTitle')}><b>{props.title}</b></p>
                <p className={classes('cardSeguroSubTitle')}>{props.subTitle}</p>
            </div>
        </div>
    )

}

export default CardSeguroComponent;
